<section class="events-page">
  <header class="events-toolbar">
    <div>
      <h1>События</h1>
      <span>Матчи, сезоны, билеты и плановая прибыль.</span>
    </div>
  </header>

  <div class="message success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <section class="events-panel">
    <div class="panel-tools">
      <div class="status-tabs" aria-label="Фильтр по статусу события">
        <button type="button" [class.active]="statusFilter === ''" (click)="setStatusFilter('')">Все</button>
        <button type="button" [class.active]="statusFilter === 'in_progress'" (click)="setStatusFilter('in_progress')">В работе</button>
        <button type="button" [class.active]="statusFilter === 'planned'" (click)="setStatusFilter('planned')">Планируется</button>
        <button type="button" [class.active]="statusFilter === 'completed'" (click)="setStatusFilter('completed')">Завершен</button>
      </div>

      <a class="action-button panel-add-button" routerLink="/dashboard/events/new">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
        <span>Добавить</span>
      </a>
    </div>

    <div class="table-wrap" *ngIf="pagedEvents.length > 0; else emptyState">
      <table class="events-table">
        <thead>
          <tr>
            <th><button type="button" (click)="setSort('date')" [attr.aria-sort]="sortState('date')">Дата</button></th>
            <th><button type="button" (click)="setSort('match')" [attr.aria-sort]="sortState('match')">Матч</button></th>
            <th><button type="button" (click)="setSort('season')" [attr.aria-sort]="sortState('season')">Сезон</button></th>
            <th><button type="button" (click)="setSort('tickets')" [attr.aria-sort]="sortState('tickets')">Билеты</button></th>
            <th><button type="button" (click)="setSort('purchase')" [attr.aria-sort]="sortState('purchase')">Закупка</button></th>
            <th><button type="button" (click)="setSort('expenses')" [attr.aria-sort]="sortState('expenses')">Расходы</button></th>
            <th><button type="button" (click)="setSort('status')" [attr.aria-sort]="sortState('status')">Статус</button></th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="event-row"
            *ngFor="let event of pagedEvents; trackBy: trackById"
            [class.event-active]="event.status !== 'completed'"
            [class.event-completed]="event.status === 'completed'"
            [routerLink]="['/dashboard/events', event.slug || event.id]"
          >
            <td>{{ formatDate(event.startsAt) }}</td>
            <td>
              <div class="match-cell">
                <div class="match-teams">
                  <span class="team-side">
                    <span class="team-logo" [style.background-image]="getLogoBackground(event.homeTeam)">{{ event.homeTeam.logoUrl ? '' : event.homeTeam.name.charAt(0) }}</span>
                    <strong>{{ event.homeTeam.name }}</strong>
                  </span>
                  <span class="match-divider">-</span>
                  <span class="team-side">
                    <span class="team-logo" [style.background-image]="getLogoBackground(event.awayTeam)">{{ event.awayTeam.logoUrl ? '' : event.awayTeam.name.charAt(0) }}</span>
                    <strong>{{ event.awayTeam.name }}</strong>
                  </span>
                </div>
                <small>{{ getSeasonTypeName(event.seasonType) }}{{ event.playoffStage ? ', ' + event.playoffStage : '' }}</small>
              </div>
            </td>
            <td>{{ event.seasonName }}</td>
            <td><strong>{{ event.summary.ticketsTotal }}</strong></td>
            <td>{{ formatMoney(event.summary.purchaseTotal) }}</td>
            <td>{{ formatMoney(event.summary.expenseTotal) }}</td>
            <td><span class="status-pill" [class.work]="event.status === 'in_progress'" [class.done]="event.status === 'completed'">{{ getStatusName(event.status) }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #emptyState>
      <div class="empty-state">
        <h3>{{ loading ? 'Обновляем события...' : 'События не найдены' }}</h3>
        <p *ngIf="!loading">Измените фильтр или добавьте первый матч.</p>
        <a class="action-button primary" routerLink="/dashboard/events/new" *ngIf="!loading">Добавить событие</a>
      </div>
    </ng-template>

    <footer class="pagination-bar">
      <span>Страница {{ page }} из {{ totalPages }}</span>
      <label class="page-size-control">
        <span>Показывать</span>
        <select class="form-select" [ngModel]="pageSize" (ngModelChange)="setPageSize($event)">
          <option *ngFor="let pageSizeOption of pageSizeOptions" [ngValue]="pageSizeOption">{{ pageSizeOption }}</option>
        </select>
      </label>
      <div class="pagination-actions">
        <button class="action-button ghost" type="button" [disabled]="page === 1" (click)="goToPage(page - 1)">Назад</button>
        <button class="action-button ghost" type="button" [disabled]="page === totalPages" (click)="goToPage(page + 1)">Вперед</button>
      </div>
    </footer>
  </section>
</section>
